import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output,
} from '@angular/core';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-table-export-button',
  templateUrl: './table-export-button.component.html',
  imports: [Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableExportButton {
  readonly label = input<string>('Export to Excel');

  readonly loading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly disabled = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly exportClick = output<void>();
}
